import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../Admin/UserManagement/EmployeeList/EmployeeListStyles.scss";
import {
  getStateAdminList,
  reset,
} from "../../../../slices/StateDOTAdmin/userManagement.slice";
import NewStateAdmin from "../NewStateAdmin/component";
import TableTitleBar from "../../../../components/TableTitleBar/TableTitleBar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useDebouncedSearch from "../../../../hooks/useDebouncedSearch";
import ListHeader from "../../../../components/Common/ListHeader";
import StateAdminTable from "./StateAdminTable";
import ErrorAlert from "../../../../components/UI/ErrorAlert/ErrorAlert";

const StateAdminList = () => {
  const userTitle = "Member";
  const history = useHistory();
  const dispatch = useDispatch();
  const { stateAdminList, stateAdminListError } = useSelector(
    (state) => state.stateAdminManagement
  );
  const [tableData, setTableData] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [paginationCurrentPage, setPaginationCurrentPage] = useState(1);
  const [paginationCurrentPageSize, setPaginationCurrentPageSize] =
    useState(10);

  const [isListLoading, setIsListLoading] = useState(false);
  const [stateAdminToEdit, setStateAdminToEdit] = useState({});
  // Ref to store the searchItem
  const isAlteredListRef = useRef();
  const [searchItem, handleSearchChange] = useDebouncedSearch((value) => {
    populateStateAdminList(value, 1);
    setPaginationCurrentPage(1);
  }, 900);

  useEffect(() => {
    isAlteredListRef.current = searchItem || paginationCurrentPage > 1;
  }, [searchItem, paginationCurrentPage]);

  useEffect(() => {
    populateStateAdminList();
    return () => {
      dispatch(reset({ isListWithSearch: isAlteredListRef.current }));
    };
  }, []);

  const populateStateAdminList = useCallback(
    (
      searchItem = "",
      currentPage = paginationCurrentPage,
      pageSize = paginationCurrentPageSize
    ) => {
      setIsListLoading(true);
      setTableData([]);
      dispatch(
        getStateAdminList(encodeURIComponent(searchItem), currentPage, pageSize)
      )
        .then(() => {
          setIsListLoading(false);
        })
        .catch(() => {
          setIsListLoading(false);
        });
    },
    [dispatch, paginationCurrentPage, paginationCurrentPageSize]
  );

  const handleDrawerOpen = (stateAdmin) => {
    setStateAdminToEdit(stateAdmin);
    setDrawerVisible(true);
  };

  const handleViewOrganization = (stateAdmin) => {
    history.push({
      pathname: `/super-admin-member-organizations-list/${stateAdmin?.id}`,
      state: {
        stateAdmin: stateAdmin,
      },
    });
  };

  return (
    <div className={`employee-list list-container`}>
      <div className="list-wrapper">
        <div className="list-body">
          {" "}
          {!isListLoading && (
            <ErrorAlert
              errorData={stateAdminListError}
              style={{ marginTop: "0px" }}
            />
          )}
          <TableTitleBar title="Member List">
            <ListHeader
              handleSearch={handleSearchChange}
              handleAddClick={() => handleDrawerOpen([])}
              searchPlaceholder={`Search ${userTitle}`}
              addButtonTitle={`ADD ${userTitle}`}
              addButtonPlaceholder={
                <>
                  {" "}
                  ADD{" "}
                  <span className="hidden-text">{userTitle.toUpperCase()}</span>
                </>
              }
            />
          </TableTitleBar>
          <StateAdminTable
            populateStateAdminList={populateStateAdminList}
            isListLoading={isListLoading}
            paginationCurrentPage={paginationCurrentPage}
            searchItem={searchItem}
            handleDrawerOpen={handleDrawerOpen}
            setPaginationCurrentPage={setPaginationCurrentPage}
            tableData={tableData}
            setTableData={setTableData}
            setPaginationCurrentPageSize={setPaginationCurrentPageSize}
            paginationCurrentPageSize={paginationCurrentPageSize}
            handleViewOrganization={handleViewOrganization}
          />
        </div>
        <NewStateAdmin
          drawerVisible={drawerVisible}
          setDrawerVisible={setDrawerVisible}
          onClose={() => setDrawerVisible(false)}
          populateStateAdminList={populateStateAdminList}
          isEdit={Object.keys(stateAdminToEdit).length}
          stateAdminData={stateAdminToEdit}
          userTitle={userTitle}
          handleViewOrganization={handleViewOrganization}
        />
      </div>
    </div>
  );
};

export default StateAdminList;
